$(document).ready(function()
{

    $(".slick-full").slick(
    {
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 7500,
        pauseOnHover:false,
    });


    $(".slick-bgs").slick(
    {
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4500,
        pauseOnHover:true,
    });


    $(".slick-bgs-lg").slick(
    {
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4500,
        pauseOnHover:true,
        slidesToShow: 0.9,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 0.95,
                    slidesToScroll: 1,
                }
            },
        ]

    });

    $(".slick-cards").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4.1,
        slidesToScroll: 4,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    centerMode: false,

                }
            }
        ]
    });

    $(".slick-blog").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        centerMode: false,
    });

    $(".slick-cards3").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3.1,
        slidesToScroll: 3,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    centerMode: false,

                }
            }
        ]
    });


    var cards = $('.slick-cards .col');
    var maxHeight = 0;

    if (cards)
    {

        window.setTimeout(function(){ 

            // Loop all cards and check height, if bigger than max then save it
            for (var i = 0; i < cards.length; i++) 
            {
                if (maxHeight < $(cards[i]).outerHeight()) 
                {
                    maxHeight = $(cards[i]).outerHeight();
                }
            }
            // Set ALL card bodies to this height
            for (var i = 0; i < cards.length; i++) 
            {
                $(cards[i]).height(maxHeight);
            }

        }, 500 );
    }

    var cards2 = $('.slick-cards3 .col');
    var maxHeight = 0;

    if (cards2)
    {

        window.setTimeout(function(){ 

            // Loop all cards and check height, if bigger than max then save it
            for (var i = 0; i < cards2.length; i++) 
            {
                if (maxHeight < $(cards2[i]).outerHeight()) 
                {
                    maxHeight = $(cards2[i]).outerHeight();
                }
            }
            // Set ALL card bodies to this height
            for (var i = 0; i < cards2.length; i++) 
            {
                $(cards2[i]).height(maxHeight);
            }

        }, 500 );
    }

});
 
// slick changes on resize
$(window).on('load resize orientationchange', function() 
{
    $('.slick-on-small').each(function(){
        var $carousel = $(this);

        if ($(window).width() > 640) 
        {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else
        {
            if (!$carousel.hasClass('slick-initialized')) 
            {
                $carousel.slick({
                  dots: true,
                  arrows: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false,
                  //autoplay: true,
                  pauseOnHover:true,
                  pauseOnFocus: false,
                  autoplaySpeed: 5000,
                });
            }
        }
    });

});
